import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import AIAssistPanel from "@/components/AIAssistPanel";
import ContactPanel from "./ContactPanel";
import { Bot, User } from "lucide-react";

interface RightSidebarProps {
  conversationId: number | null;
  contactId: number;
  contactPhone: string | null;
  contactName: string | null;
  onUseSuggestion: (text: string) => void;
  onAddContact: () => void;
  onEditContact: () => void;
}

export default function RightSidebar({
  conversationId,
  contactId,
  contactPhone,
  contactName,
  onUseSuggestion,
  onAddContact,
  onEditContact,
}: RightSidebarProps) {
  return (
    <div className="w-full md:w-80 md:border-l md:border-border flex flex-col shrink-0 bg-card h-full">
      <Tabs defaultValue="ia" className="flex flex-col flex-1 min-h-0">
        <TabsList className="w-full rounded-none border-b bg-transparent h-auto p-0 shrink-0">
          <TabsTrigger
            value="ia"
            className="flex-1 rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:shadow-none py-2.5 text-xs font-medium gap-1.5"
          >
            <Bot className="w-3.5 h-3.5" />
            Assistente IA
          </TabsTrigger>
          <TabsTrigger
            value="contato"
            className="flex-1 rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:shadow-none py-2.5 text-xs font-medium gap-1.5"
          >
            <User className="w-3.5 h-3.5" />
            Contato
          </TabsTrigger>
        </TabsList>

        <TabsContent value="ia" className="flex-1 overflow-hidden mt-0 data-[state=inactive]:hidden">
          <AIAssistPanel
            conversationId={conversationId}
            onUseSuggestion={onUseSuggestion}
          />
        </TabsContent>

        <TabsContent value="contato" className="flex-1 overflow-hidden mt-0 data-[state=inactive]:hidden">
          <ContactPanel
            contactId={contactId}
            contactPhone={contactPhone}
            contactName={contactName}
            onAddContact={onAddContact}
            onEditContact={onEditContact}
          />
        </TabsContent>
      </Tabs>
    </div>
  );
}
